import React from 'react';
import DocumentReader from './DocumentReader';
import { documentTitle, documentSlug, parts } from './content/algebraReference';

export default function AlgebraReference() {
  return (
    <DocumentReader
      documentId={documentSlug}
      title={documentTitle}
      intro="Quick-lookup formulas and rules for Algebra — linear equation forms, solving equations and inequalities, systems, and graphing inequalities."
      parts={parts}
    />
  );
}
